export class FilterLogsModal {
	period: number = 24
	dateStart?: Date
	dateEnd?: Date
	integrationsId?: Array<number>
	sites?: Array<number>
}